import React, { useState, useMemo } from 'react';
import { Collapse } from 'antd';
import { CrfCicloOrcamentarioProjetoDadosGerais, getCicloOrcamentarioProjetoDadosGerais } from '@app/api/crf/crfRelatorioCicloorcamentario';
import RelatorioCicloOrcamentarioProjetoDadosGerais from '../RelatorioCicloOrcamentarioProjeto/dadosGerias';


const { Panel } = Collapse;
interface ResultCicloAnoProps {
    projetoId: string;
}


const DadosGerias = (props: ResultCicloAnoProps) => {
    const { projetoId } = props;
    const [cicloOrcamentarioProjetoDadosGerais, setCicloOrcamentarioProjetoDadosGerais] = useState<CrfCicloOrcamentarioProjetoDadosGerais>();

    useMemo(() => {
        if (projetoId) {
            getCicloOrcamentarioProjetoDadosGerais(projetoId).then((data) => {
                setCicloOrcamentarioProjetoDadosGerais(data);
            });
        }
    }, [projetoId]);

    return (
        <>
            <RelatorioCicloOrcamentarioProjetoDadosGerais
                cicloOrcamentarioProjetoDadosGerais={cicloOrcamentarioProjetoDadosGerais ? cicloOrcamentarioProjetoDadosGerais : {} as CrfCicloOrcamentarioProjetoDadosGerais}
            />
        </>
    );

}

export default DadosGerias;

